module.exports = __webpack_public_path__ + "img/xiangyu.a989daaa.png";